export default __webpack_public_path__ + "static/media/logo1.e9d0f6f9.png";